let SERVER_URL = process.env.REACT_APP_API_URL;

const getToken = () => {
  return JSON.parse(localStorage.getItem("key"));
};

const getUserId = () => {
  return Number(localStorage.getItem("userId"));
};

const headers = {
  Accept: "application/json",
  "Content-Type": "application/json",
  authorization: "",
};
export const getSkills = () => {
  const endpoint = `api/group/skillSet/all`;
  const url = SERVER_URL + endpoint;
  return fetch(url, {
    method: "GET",
    headers: { ...headers, authorization: `Bearer ${getToken()?.value}` },
  })
    .then((res) => res.json())
    .then((data) => data.data);
};
export const getSkillByDeptID = (id) => {
  const endpoint = `api/group/skillSetBydeptid/${id}`;
  const url = SERVER_URL + endpoint;
  return fetch(url, {
    method: "GET",
    headers: { ...headers, authorization: `Bearer ${getToken()?.value}` },
  })
    .then((res) => res.json())
    .then((data) => data);
};
export const getDepartments = () => {
  const endpoint = `api/group/skillSet/all`;
  const url = SERVER_URL + endpoint;
  return fetch(url, {
    method: "GET",
    headers: { ...headers, authorization: `Bearer ${getToken()?.value}` },
  })
    .then((res) => res.json())
    .then((data) => data.data);
};



export const httpCreateSubSkill = (body) => {
  const endpoint = "api/group/skillSet/subSkill/create";
  const url = SERVER_URL + endpoint;
  return fetch(url, {
    method: "POST",
    headers: { ...headers, authorization: `Bearer ${getToken()?.value}` },
    body: JSON.stringify({
      ...body,
      created_by: getUserId(),
      created_on: new Date(),
    }),
  })
    .then((res) => res.json())
    .then((data) => data);
};

export const httpDeleteSubSkillset = (id) => {
  // console.log(id)
  const endpoint = "api/group/subSkillSet/deleted/" + id;
  const url = SERVER_URL + endpoint;
  return fetch(url, {
    method: "DELETE",
    headers: { ...headers, authorization: `Bearer ${getToken()?.value}` },
  })
    .then((res) => res.json())
    .then((data) => data);
};

export const httpUpdateSubSkill = (id, body) => {
  // console.log(id);
  // console.log(body)
  // return false;
  const endpoint = `api/group/skillSet/subSkill/update/${id}`;
  const url = SERVER_URL + endpoint;
  return fetch(url, {
    method: "PUT",
    headers: { ...headers, authorization: `Bearer ${getToken()?.value}` },
    body: JSON.stringify({
      ...body,
      updated_by: getUserId(),
      updated_on:new Date()
    }),
  })
    .then((res) => res.json())
    .then((data) => data);
};
